import type { UploadFileModel } from '../../models/UploadFileModel';

export const defaultUploadFileData: UploadFileModel = {
  url: '',
  fileName: '',
  fileType: '',
};
